import React from 'react';

const Link = ({ 
  height = '48px', 
  width = '48px', 
  color = '#B3B3B3', 
  secondaryColor = '#D8D8D8', 
  shadowColor = '#999999' 
}) => (
  <svg className="svg-icon" height={height} width={width} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <title>link</title>
    <g>
      <path d="M23.64645,36.37437l-4.24264,4.24264c-3.31387,3.31387-8.70694,3.31387-12.02082,0 c-3.31387-3.31387-3.31387-8.70694,0-12.02081l4.24264-4.24264c3.31387-3.31387,8.70694-3.31387,12.02081,0 S26.96032,33.0605,23.64645,36.37437z M9.50431,30.71751c-2.14411,2.14411-2.14411,5.63407,0,7.77818s5.63407,2.14411,7.77818,0 l4.24264-4.24264c2.14411-2.14411,2.14411-5.63407,0-7.77817s-5.63407-2.14411-7.77817,0L9.50431,30.71751z" fill={color}/>
      <path d="M40.61701,19.40381l-4.24264,4.24264c-3.31387,3.31387-8.70695,3.31387-12.02082,0 s-3.31387-8.70694,0-12.02081l4.24264-4.24264c3.31387-3.31387,8.70695-3.31387,12.02081,0 C43.93088,10.69686,43.93088,16.08993,40.61701,19.40381z M26.47487,13.74695c-2.14411,2.14411-2.14411,5.63407,0,7.77817 s5.63407,2.14411,7.77817,0l4.24264-4.24264c2.14411-2.14411,2.14411-5.63407,0-7.77818s-5.63407-2.14411-7.77818,0 L26.47487,13.74695z" fill={color}/>
      <path d="M32.13173,17.98959L17.98959,32.13173c-0.58557,0.58557-1.53575,0.58557-2.12132,0 c-0.58557-0.58557-0.58557-1.53575,0-2.12132l14.14214-14.14214c0.58557-0.58557,1.53575-0.58557,2.12132,0 C32.7173,16.45384,32.7173,17.40402,32.13173,17.98959z" fill={secondaryColor}/>
      <path d="M24.60758,25.51374l-2.17264,2.17264c0.37513,0.67327,0.60262,1.40718,0.6734,2.15503l2.47341-2.47341 C25.33864,26.72006,25.01405,26.09767,24.60758,25.51374z" fill={shadowColor}/>
      <path d="M27.36799,25.58175l2.47341-2.47341c-0.74785-0.07078-1.48176-0.29827-2.15503-0.6734l-2.17264,2.17264 C26.09767,25.01405,26.72006,25.33864,27.36799,25.58175z" fill={shadowColor}/>
    </g>
  </svg>
);

export default Link;
